import React, { Component } from 'react';
import { Layout } from 'antd';
import BaseMenu from './BaseMenu';
import Logo from './Logo';
import Title from './Title'
import { getDefaultCollapsedSubMenus, getFlatMenuKeys } from './utils';
// import { getFlatMenuKeys } from './utils';

class SiderMenu extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      flatMenuKeys: [],
      openKeys: [],
      path: '',
    };
    this.isMainMenu = (key) => {
      const { menuData } = this.props;
      return menuData.some((item) => item.path === key);
    };
    this.onOpenChange = (openKeys) => {
      const moreThanOne =
        openKeys.filter((openKey) => this.isMainMenu(openKey)).length > 1;
      this.setState({
        openKeys: moreThanOne ? [openKeys[openKeys.length - 1]] : [...openKeys],
      });
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { path } = prevState;
    const { currentRoute, menuData } = nextProps;
    const flatMenuKeys = getFlatMenuKeys(menuData);
    if (currentRoute.path !== path) {
      return {
        path: currentRoute.path,
        flatMenuKeys,
        openKeys: getDefaultCollapsedSubMenus(flatMenuKeys, currentRoute.path),
      };
    }
    return null;
  }

  render() {
    const {
      className,
      style,
      collapsed,
      onCollapse,
      menuData,
      currentRoute,
      titleName,
      isDocMenu,
      sideType,
      titleStyle = {},
      layoutStyle = {},
      theme
    } = this.props;
    const { openKeys, flatMenuKeys } = this.state;
    const logoOrTitle = isDocMenu ? (<Title titleStyle={titleStyle} titleName={titleName} />) : (<Logo />)
    return (
      <Layout.Sider
        className={className}
        trigger={null}
        collapsed={collapsed}
        collapsible
        onCollapse={onCollapse}
        width={300}
        style={layoutStyle}
      >
        {logoOrTitle}
        <BaseMenu
          mode="inline"
          isDocMenu={isDocMenu}
          menuData={menuData}
          currentRoute={currentRoute}
          collapsed={collapsed}
          onOpenChange={this.onOpenChange}
          flatMenuKeys={flatMenuKeys}
          openKeys={openKeys}
          setMenuItemKeyPath={this.props.setMenuItemKeyPath}
          setDocId={this.props.setDocId}
          style={style}
          sideType={sideType}
          theme={theme}
        />
      </Layout.Sider>
    );
  }
}

export default SiderMenu;
